module.exports = __webpack_public_path__ + "static/media/eritreia.33345b12.jpg";